import React, { useState, useEffect } from "react";
import { NavLink, Outlet } from "react-router-dom";
import "../../../src/assets/styles/admin-layout.scss";

/** Ikony menu — solid */
const menuItems = [
    { label: "Dashboard", key: "", icon: "dashboard" },
    { label: "Treści", key: "contents", icon: "book" },
    { label: "Serie", key: "series", icon: "layers" },
    { label: "Kategorie", key: "categories", icon: "folders" },
    { label: "Tagi", key: "tags", icon: "tag" },
    { label: "Autorzy", key: "authors", icon: "users" },
	{ label: "Karty Słówka", key: "vocab-cards", icon: "media" },
    { label: "Media", key: "media", icon: "media" },
    { label: "Generator audio", key: "generate-audio", icon: "audio" },
    { label: "Kody Rabatowe", key: "promocodes", icon: "percent" },
    { label: "Oceny", key: "rate", icon: "star" },
    { label: "Powiadomienia", key: "notifications", icon: "notification" },
    { label: "Użytkownicy", key: "users", icon: "user" },
    { label: "Błędy", key: "errors", icon: "alert" },
    { label: "Regulamin", key: "rules", icon: "doc" },
];

export default function AdminLayout() {
    const [collapsed, setCollapsed] = useState(false);
    const [mobileOpen, setMobileOpen] = useState(false);

    // ESC zamyka szufladę
    useEffect(() => {
        const onKey = (e: KeyboardEvent) => { if (e.key === "Escape") setMobileOpen(false); };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, []);

    return (
        <div className={`admin-shell ${mobileOpen ? "is-drawer" : ""}`}>
            <div className="drawer-overlay" onClick={() => setMobileOpen(false)} />

            {/* Przycisk otwierający menu na mobile */}
            <button
                className="mobile-open"
                aria-label="Otwórz nawigację"
                aria-expanded={mobileOpen}
                onClick={() => setMobileOpen(true)}
            >
                {burger()}
            </button>

            <aside className={`side ${collapsed ? "is-collapsed" : ""} ${mobileOpen ? "is-open" : ""}`}>
                <div className="side-top">
                    <a className="brand" href="/">
                        <span className="brand-text">PolyLect</span>
                    </a>
                    <button
                        className="btn-icon collapse-btn"
                        aria-label={collapsed ? "Rozwiń" : "Zwiń"}
                        onClick={() => setCollapsed(v => !v)}
                    >
                        {collapsed ? chevronRight() : chevronLeft()}
                    </button>
                </div>

                <div className="side-group">
                    <ul className="nav">
                        {menuItems.map((item) => (
                            <li key={item.key} className="nav-li">
                                <NavLink
                                    to={item.key}
                                    end
                                    className={({ isActive }) => (isActive ? "nav-a is-active" : "nav-a")}
                                    onClick={() => setMobileOpen(false)}
                                    title={collapsed ? item.label : undefined}
                                >
                                    <span className="nav-ico">{icon(item.icon)}</span>
                                    <span className="nav-label">{item.label}</span>
                                </NavLink>
                            </li>
                        ))}
                    </ul>
                </div>
            </aside>

            <div className="content">
                <main className="main">
                    <Outlet />
                </main>
            </div>
        </div>
    );
}

/* ===== Ikony (solid) ===== */
function icon(name: string) {
    const path: Record<string, string> = {
        dashboard:
            '<circle cx="12" cy="12" r="10"/>' +
            '<path d="M12 2v10h10A10 10 0 0 0 12 2z" fill="#fff"/>' +
            '<path d="M12 12H2a10 10 0 0 0 10 10v-10z" fill="#fff" opacity=".18"/>',
        book:
            '<path d="M3 6a2 2 0 0 1 2-2h7v16H5a2 2 0 0 1-2-2V6z"/>' +
            '<path d="M12 4h7a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-7V4z"/>',
        layers:
            '<path d="M12 3l9 5-9 5-9-5 9-5z"/>' +
            '<path d="M21 13l-9 5-9-5v3l9 5 9-5v-3z"/>',
        folders:
            '<path d="M4 6h5l2 2h9a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z"/>',
        tag:
            '<path d="M10 3h4l7.59 7.59a2 2 0 0 1 0 2.82l-7.18 7.18a2 2 0 0 1-2.83 0L3 13V7a4 4 0 0 1 4-4z"/>' +
            '<circle cx="8" cy="8" r="1.6" fill="#ffffff"/>',
        users:
            '<circle cx="12" cy="9" r="2.6"/>' +
            '<circle cx="7.4" cy="11" r="1.9"/>' +
            '<circle cx="16.6" cy="11" r="1.9"/>' +
            '<path d="M7 18a5 5 0 0 1 10 0v1H7v-1z"/>' +
            '<path d="M2 19a3.8 3.8 0 0 1 6.2-3V20H2v-1z"/>' +
            '<path d="M22 19v1h-6.2v-4A3.8 3.8 0 0 1 22 19z"/>',
        media:
            '<rect x="3" y="4" width="18" height="16" rx="2"/>' +
            '<circle cx="9" cy="9" r="2.2" fill="#ffffff"/>' +
            '<path d="M6 18l4.5-4 2.5 2 3.5-3 5 5H6z" fill="#ffffff"/>',
        percent:
            '<path d="M3 6.75A2.25 2.25 0 0 1 5.25 4.5H12c.6 0 1.17.24 1.59.66l6.75 6.75a2.25 2.25 0 0 1 0 3.18l-4.91 4.91a2.25 2.25 0 0 1-3.18 0L5.5 13.2a2.25 2.25 0 0 1-.66-1.59V6.75z"/>' +
            '<circle cx="7.25" cy="7.25" r="1.35"/>' +
            '<rect x="9" y="11" width="2" height="8" rx="1" transform="rotate(-45 10 15)"/>' +
            '<circle cx="14.9" cy="14.9" r="1.75"/>',
        star:
            '<path d="M12 3l2.8 5.7L21 10l-4.6 4.2.6 6.1L12 17.7 7 20.3l.6-6.1L3 10l6.2-1.3L12 3z"/>',
        notification:
            '<path d="M12 3a6 6 0 0 0-6 6c0 5.2-2.5 7-2.5 7H20.5S18 14.2 18 9a6 6 0 0 0-6-6z"/>' +
            '<circle cx="12" cy="21" r="2"/>',
        user:
            '<circle cx="12" cy="8" r="4"/>' +
            '<path d="M4 21a8 8 0 0 1 16 0v1H4v-1z"/>',
        alert:
            '<path d="M12 3a2 2 0 0 1 1.73 1L22 19a2 2 0 0 1-1.73 3H3.73A2 2 0 0 1 2 19l8.27-15A2 2 0 0 1 12 3z"/>' +
            '<rect x="11" y="9" width="2" height="6" rx="1" fill="#ffffff"/>' +
            '<circle cx="12" cy="17.5" r="1.4" fill="#ffffff"/>',
        doc:
            '<rect x="5" y="3" width="14" height="18" rx="2"/>' +
            '<path d="M9 7h6" stroke="#ffffff" stroke-width="1.6" stroke-linecap="round"/>' +
            '<path d="M9 11h6" stroke="#ffffff" stroke-width="1.6" stroke-linecap="round"/>' +
            '<path d="M9 15h4" stroke="#ffffff" stroke-width="1.6" stroke-linecap="round"/>',
 
    };
    const d = path[name] || '<circle cx="12" cy="12" r="6"/>';
    return (
        <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" stroke="none"
            dangerouslySetInnerHTML={{ __html: d }} />
    );
}

const chevronLeft = () => (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="15 18 9 12 15 6" />
    </svg>
);
const chevronRight = () => (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="9 18 15 12 9 6" />
    </svg>
);
const burger = () => (
    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="3" y1="6" x2="21" y2="6" /><line x1="3" y1="12" x2="21" y2="12" /><line x1="3" y1="18" x2="21" y2="18" />
    </svg>
);
